import {get, find, sum, filter, head} from 'lodash';

import {processStringContent, replaceSpecialChars} from 'utils/content';
import Answer from './Answer';
import Expression from './Expression';
import Graphing from './Graphing';
import Poll from './Poll';
import Spreadsheet from './Spreadsheet';
import AnswerChoice from "./AnswerChoice";
import {getQuestionID} from 'utils/challenge/challengeComponent'
import InlinePollResponse from "./InlinePollResponse";


export default class DataCompiler {
    compile(rows, streams, stream_entities, lesson) {
        const is_new = this.isNewDataModel(lesson);
        if (is_new) {
            rows.push(['Student', 'Question', 'Answer(s)']);
        } else {
            // Not supporting old data model any more
            return null;
        }

        streams
            .map((stream) => {
                stream_entities
                    .filter(stream_entity => {
                        if (is_new) {
                            const rows = get(stream_entity, 'data.card_content.rows', []);
                            return sum(
                                rows.map((row) => {
                                    const components = get(row, 'components', []);
                                    return filter(components, (c) => {
                                        return c.type === 'question' || c.type === 'poll.block';
                                    }).length;
                                })
                            ) > 0;
                        } else {
                            // Not supporting old data model any more
                            return false;
                        }
                    })
                    .map((stream_entity) => {
                        this.compileNew(rows, stream, stream_entity);
                    });
            });

        return rows;
    }

    compileNew(rows, stream, stream_entity) {
        const user = stream.user;
        const polls = stream_entity.polls;
        const user_votes = filter(stream.votes, {stream_entity_id: stream_entity.id});
        const responses = filter(stream.responses, {stream_entity_id: stream_entity.id});

        stream_entity.data.card_content.rows.map((row) => {
            row.components.map((component) => {
                let cells = [];
                cells.push(user.fname + ' ' + head(user.lname));
                cells.push(this.getQuestion(stream_entity, component));

                const question_id = getQuestionID(component, stream_entity.questions)
                const poll = find(polls, (p) => p.question_id == question_id)
                const response = find(responses, {question_id})

                switch (true) {
                    case component.type.startsWith('answer.'):
                        if (!response) {
                            break
                        }
                        switch (true) {
                            case component.type === 'answer.graphing':
                                new Graphing().render(cells, response);
                                break;
                            case component.type.startsWith('answer.expression'):
                                new Expression().render(cells, response);
                                break;
                            case component.type.startsWith('answer.choice_'):
                                new AnswerChoice().render(cells, component.data.options, response);
                                break;
                            default:
                                new Answer().render(cells, response);
                        }
                        break;
                    case component.type === 'poll.inline':
                        if (!poll) {
                            break
                        }
                        if (response) {
                            InlinePollResponse(cells, poll, response);
                        }
                        break;
                    case component.type === 'poll.block':
                        // In case of Poll block, question_id is undefined
                        if (!poll) {
                            break
                        }
                        const vote = find(user_votes, (v) => v.poll_id === poll.id);
                        if (vote) {
                            new Poll().render(cells, vote);
                        }
                        break;
                    case component.type === 'spreadsheet':
                        if (response) {
                            new Spreadsheet().render(cells, response);
                        }
                        break;
                }

                if (cells.length > 2) {
                    rows.push(cells);
                }
            })
        });
    }

    getQuestion(stream_entity, component) {
        const q_number = component.data && component.data.question_number ? component.data.question_number : null;
        if (q_number) {
            let question_component;
            find(stream_entity.data.card_content.rows, (row) => {
                return question_component = find(row.components, (component) => {
                    return get(component, ['data', 'question_number']) === q_number && 'question' === get(component, ['type']);
                });
            });
            if (question_component) {
                const question_text = processStringContent(
                    replaceSpecialChars(get(question_component, ['data', 'question']), {convert_katex: false}),
                    {
                        keep_html: false,
                        convert_html: false,
                        convert_math: false
                    }
                ).substr(0, 500);
                return 'Q' + q_number + ': ' + question_text;
            } else {
                return '';
            }
        } else if (component.data && component.type.startsWith('poll.')) {
            if (component.data.title) {
                return component.data.title;
            } else {
                return 'Poll';
            }
        } else {
            return '';
        }
    }

    isNewDataModel(lesson) {
        return lesson.challenge_version.data_version > 0;
    }
}
